// ProtectedRoute.js
import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  if (!user) {
    sessionStorage.setItem('auth:reason', 'expired');
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
